import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { appliedFilterTemplateSelector } from "./appliedFilterTemplateSelector";

export const appliedFilterTemplateFiltersSelector = createDraftSafeSelector(
  [appliedFilterTemplateSelector],
  (filterTemplate) => {
    return filterTemplate?.filters;
  },
);
